import React, {useState} from 'react';
import PropTypes from 'prop-types';

import MenuList from './MenuList';
import withIntl from '../../../lib/withIntl';

function MixingMenu({intl, selected, disabled, onClick, tooltipMessage}) {
  const [hovered, setHovered] = useState(false);
  const getStyle = () => {
    if (disabled) {
      return {
        border: '1px solid #E0E0E0',
        backgroundColor: '#E0E0E0',
        color: '#999999',
      };
    }

    if (selected) {
      return {
        border: '1px solid #2D9CDB',
        backgroundColor: 'white',
        color: '#2D9CDB',
      };
    }

    if (hovered) {
      return {
        border: '1px solid #006AF5',
        backgroundColor: '#006AF5',
        color: 'white',
      };
    }

    return {
      border: '1px solid #2D9CDB',
      backgroundColor: '#2D9CDB',
      color: 'white',
    };
  };

  return (
    <MenuList.Item
      name={
        <div style={{color: getStyle().color}}>
          <div>{intl.formatMessage({id: 'protocolEditor.mixing.menu'})}</div>
        </div>
      }
      // eslint-disable-next-line
      imgPath={`./svg/protocol-editor/mixing${selected ? '-selected' : disabled ? '-disabled' : ''}.svg`}
      onClick={() => {
        if (disabled || selected) {
          return;
        }

        onClick();
      }}
      size={MenuList.Size.SMALL}
      disabled={disabled}
      style={getStyle()}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      tooltipMessage={tooltipMessage}
    />
  );
}

MixingMenu.propTypes = {
  intl: PropTypes.any.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tooltipMessage: PropTypes.string,
};

MixingMenu.defaultProps = {
  selected: false,
  disabled: false,
  onClick: () => {},
  tooltipMessage: '',
};

export default withIntl(MixingMenu);
